exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".average{position:fixed;top:0;left:0;width:100%;height:100%;z-index:99999;background:#fff;display:flex;align-items:center;justify-content:center}.average .grid-c__box__item{outline:1px solid transparent}.average .grid-c__box__item.active{background:#000}", ""]);

// exports
